<template>
  <main-layout>
    <template v-if="isMobile">
      <livechat-mobile></livechat-mobile>
    </template>
    <template v-else>
      <livechat></livechat>
      <audio
        v-show="false"
        id="noti_sound"
        src="/static/sound/noti_sound.m4a"
        type="audio/x-m4a"
        preload="auto"
        controls
      ></audio>
    </template>
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Livechat from './Livechat.vue'
import LivechatMobile from './LivechatMobile'
import dayjs from 'dayjs'

export default {
  data: () => ({
    isMobile: false
  }),
  components: {
    Livechat,
    LivechatMobile
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist'
    })
  },
  created() {
    const vm = this
    vm.$set(vm.$store.state.livechat, 'app', vm.$route.query.app)
    vm.$set(vm.$store.state.livechat, 'userid', vm.$route.query.userid)
    this.$store.commit('SELECT_PAGE_LIVECHAT', {
      pageID: this.selectedBot.pageid,
      lineModularBotID: this.selectedBot.line_modular_botid,
    })
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  beforeMount: function() {
    var bot = this.botlist.find(el => {
      return el.pageid == this.$store.state.livechat.pageid
    })

    if (
      !bot ||
      !(
        (bot.pagetype == 'enterprise') ||
        this.$store.state.livechatPageIdList.includes(bot.pageid) ||
        (bot.theme == 'ecommercebasic' && bot.pageid == '270028443161479') ||
        bot.pagetype != 'enterprise'
      )
    ) {
      if (!this.$aston.astonpages.includes(this.$store.state.livechat.pageid)) {
        this.$router.push('/' + this.$store.getters.currentLang + '/dashboard').catch(() => {})
      }
    }
  },

  mounted() {
    var vm = this
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
    if (this.selectedBot.theme == 'universalutilities') {
      vm.$store.dispatch('loadLinePushMessageCount', {
        dateform: dayjs()
          .startOf('month')
          .format('YYYY-MM-DD'),
        dateto: dayjs()
          .endOf('month')
          .format('YYYY-MM-DD')
      })
    }

    if (this.$aston.astonpages.includes(this.$store.state.livechat.pageid)) {
      this.$store.dispatch('loadAstonAdmins')
    }
  },

  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 960 || this.detectMob()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatView.vue